import { REHYDRATE } from "redux-persist";

import AuthenticationActionTypes from "./types";
import AuthenticationUtils from "./utils";

const SESSION_DURATION = 3600000; // 1h

const initialState = {
  sessionExpiredAt: undefined,
  refresh_token: undefined,
  access_token: undefined,
  keepLoggedIn: false,
  error: false,
  isAuthenticated: false,
  initialized: false,
};

const AuthenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      if (
        action.payload &&
        AuthenticationUtils.shouldPersistSession(action.payload.Authentication)
      ) {
        return state;
      }

      return initialState;
    case AuthenticationActionTypes.LOG_OUT:
      return initialState;
    case AuthenticationActionTypes.SET_AUTH:
      return {
        ...state,
        ...action,
        sessionExpiredAt: new Date().getTime() + SESSION_DURATION,
        initialized: true,
        isAuthenticated: true,
      };
    default:
      return state;
  }
};

export default AuthenticationReducer;
